<template>
    <div class="zone">
        <div class="container">
            
            <div class="text-center pt-5" v-if="httpLoading">
                <a-spin size="large" />
            </div>

            <template v-else-if="info.title">
                <o-breadcrumb :category="info.category" />
                <div class="bg-white p-4">
                    <user-status @update="update" />
    
                    <zone-header
                        class="mb-3"
                        :info="info"
                        v-model="mode"
                        @view-large="viewImage"
                    />
                    <zone-slideshow
                        v-show="mode == 'slide'"
                        :active.sync="active"
                        :list="info.list"
                    />
                    <zone-listview v-show="mode == 'list'" :list="info.list" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import OBreadcrumb from "@/components/Breadcrumb"
import ZoneHeader from "@/components/ZoneHeader"
import ZoneSlideshow from "@/components/ZoneSlideshow"
import ZoneListview from "@/components/ZoneListview"
import { zones } from "@/config/navigations"
import { view } from "../store/preview"

export default {
    data() {
        return {
            info: {},
            mode: "slide",
            active: 0
        }
    },

    async created() {
        // this.$request(`/api/works/details/${this.$route.params.id}`, { middlewares: ['user'] })
        this.update()
    },

    methods: {
        viewImage() {
            const image = this.info.list[this.active]

            view(image.img)
        },
        async update() {
            const info = await this.$request(
                `/api/works/details/${this.$route.params.id}`,
                { middlewares: ["token"] }
            )

            this.info = {
                ...info,
                title: info.name,
                list: JSON.parse(info.medias)
            }
        }
    },

    components: { OBreadcrumb, ZoneHeader, ZoneSlideshow, ZoneListview }
}
</script>